import React, { useState } from 'react';
import { Card, Row, Col, Typography, Table, Tooltip, Progress, Button } from "antd";
import { DownOutlined, UpOutlined, EnvironmentOutlined } from '@ant-design/icons';

const { Text } = Typography;
import { getFullStateName } from './utils';
const StatePerformance = ({ stateSummary }) => {
  const [expandedState, setExpandedState] = useState(null);

  // Sort states by total sales
  const sortedStates = Object.entries(stateSummary || {})
    .sort(([,a],[,b]) => b.total_sales - a.total_sales);
console.log(sortedStates, "sorted states")
  // City table columns for expanded state view
  const cityColumns = [
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      sorter: (a, b) => a.localeCompare(b),
    },
    {
      title: 'Customers',
      dataIndex: 'customer_count',
      key: 'customer_count',
      sorter: (a, b) => a - b,
      render: val => val.toLocaleString(),
    },
  ];

  return (
    <Card title="State Performance by City Distribution">
      <Row gutter={[16, 16]}>
        {sortedStates.map(([state, data]) => {
          const isExpanded = expandedState === state;
          const ordersPerCustomer = data.orders_per_customer;
          let statusColor = 'orange';
          if (ordersPerCustomer < 1) statusColor = 'red';
          else if (ordersPerCustomer > 3) statusColor = 'green';
          else if (ordersPerCustomer > 2) statusColor = 'blue';

          // Calculate percentage of total customers
          const totalCustomersAllStates = sortedStates.reduce((sum, [, stateData]) => sum + stateData.customer_count, 0);
          const customerPercentage = totalCustomersAllStates > 0 ? 
            (data.customer_count / totalCustomersAllStates) * 100 : 0;
 const fullStateName = getFullStateName(state);
          return (
            <Col xs={24} key={state}>
              <Card 
                size="small" 
                style={{ marginBottom: 8 }}
                bodyStyle={{ padding: '12px 16px' }}
              >
                <Row justify="space-between" align="middle">
                  <Col xs={24} md={6}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      
                      <Text strong style={{ fontSize: '16px' }}>{fullStateName}</Text>
                    </div>
                  </Col>
                  <Col xs={12} md={4}>
                    <Tooltip title="Number of customers in this state">
                      <div>
                        <Text type="secondary">Customers:</Text>
                        <Text strong style={{ marginLeft: 8 }}>{data.customer_count.toLocaleString()}</Text>
                      </div>
                    </Tooltip>
                  </Col>
                  <Col xs={12} md={3}>
                    <Tooltip title="Number of cities with customers in this state">
                      <div>
                        <Text type="secondary">Cities:</Text>
                        <Text strong style={{ marginLeft: 8 }}>{data.city_count}</Text>
                        <EnvironmentOutlined style={{ marginLeft: 4, color: '#1890ff' }} />
                      </div>
                    </Tooltip>
                  </Col>
                  <Col xs={12} md={4}>
                    <Tooltip title="Total sales in this state">
                      <div>
                        <Text type="secondary">Sales:</Text>
                        <Text strong style={{ marginLeft: 8 }}>
                          ${data.total_sales.toLocaleString(undefined, {maximumFractionDigits: 0})}
                        </Text>
                      </div>
                    </Tooltip>
                  </Col>
                  <Col xs={12} md={4}>
                    <Tooltip title="Total orders in this state">
                      <div>
                        <Text type="secondary">Orders:</Text>
                        <Text strong style={{ marginLeft: 8 }}>
                          {data.order_count.toLocaleString()}
                        </Text>
                      </div>
                    </Tooltip>
                  </Col>
                  <Col xs={12} md={5}>
                    <Tooltip title="Orders per customer">
                      <div>
                        <Text type="secondary">Orders/Customer:</Text>
                        <Text 
                          strong 
                          style={{ 
                            marginLeft: 8, 
                            color: ordersPerCustomer < 1 ? '#f5222d' : ordersPerCustomer > 3 ? '#52c41a' : '#1890ff'
                          }}
                        >
                          {ordersPerCustomer.toFixed(1)}
                        </Text>
                      </div>
                    </Tooltip>
                  </Col>
                </Row>
                
                <Tooltip title={`${customerPercentage.toFixed(1)}% of total customers`}>
                  <Progress 
                    percent={customerPercentage} 
                    showInfo={false} 
                    strokeColor={statusColor}
                    size="small"
                    style={{ marginTop: 8 }}
                  />
                </Tooltip>
                
           
              </Card>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

export default StatePerformance;
